

export function Sleep(ms: number) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

export function PromiseTimeout<T>(promise: Promise<T>, timeout: number): Promise<T> {
  return new Promise((resolve, reject) => {
    const timer = setTimeout(() => {
      reject(new Error('Timeout'));
    }, timeout);
    promise.then(resolve, reject).finally(() => clearTimeout(timer));
  });
}